"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../helpers/wiget-helper/constants");

var chart_common_1 = __importDefault(require("./chart-common"));

var Line =
/*#__PURE__*/
function (_chart_common_1$defau) {
  _inherits(Line, _chart_common_1$defau);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _getPrototypeOf(Line).apply(this, arguments));
  }

  _createClass(Line, [{
    key: "generateSchema",
    value: function generateSchema() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.setAxes();
                _context.t1 = this.setScales();
                _context.t2 = this.setMarks();
                _context.t3 = this.bindData();
                _context.t4 = this.interactionConfig();
                _context.t5 = this.resolveScheme();
                _context.t6 = {
                  type: "fit",
                  contains: "padding"
                };
                _context.t7 = [];
                _context.t8 = _toConsumableArray;
                _context.next = 11;
                return this.resolveSignals();

              case 11:
                _context.t9 = _context.sent;
                _context.t10 = (0, _context.t8)(_context.t9);
                _context.t11 = [{
                  name: "hover",
                  value: null,
                  on: [{
                    events: "@cell:mouseover",
                    update: "datum"
                  }, {
                    events: "@cell:mouseout",
                    update: "null"
                  }]
                }, {
                  name: "width",
                  value: "",
                  on: [{
                    events: {
                      source: "window",
                      type: "resize"
                    },
                    update: "containerSize()[0]*0.95"
                  }]
                }];
                _context.t12 = _context.t7.concat.call(_context.t7, _context.t10, _context.t11);
                this.schema = {
                  axes: _context.t0,
                  scales: _context.t1,
                  marks: _context.t2,
                  data: _context.t3,
                  interaction_config: _context.t4,
                  config: _context.t5,
                  autosize: _context.t6,
                  signals: _context.t12
                };

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setGenericSettings",
    value: function setGenericSettings() {
      this.schema = Object.assign(Object.assign({}, this.schema), {
        autosize: {
          type: "fit",
          contains: "padding"
        }
      });
    }
  }, {
    key: "interactionConfig",
    value: function interactionConfig() {
      var _a;

      var configuration = this.store.configuration;
      return [{
        name: "tooltip",
        config: {
          fields: [{
            column: "datum.y",
            property: this.resolveName('y'),
            type: "number",
            format: '.2s'
          }, {
            column: "datum.x",
            property: this.resolveName('x'),
            type: ((_a = configuration.category) === null || _a === void 0 ? void 0 : _a.type) || 'string',
            format: this.resolveFormat('x')
          }]
        }
      }];
    }
  }, {
    key: "setScales",
    value: function setScales() {
      return [{
        name: "x",
        type: this.isDate() ? 'utc' : 'point',
        range: "width",
        domain: Object.assign({
          data: "table",
          field: "x"
        }, this.isDate() ? {
          sort: true
        } : {})
      }, {
        name: "y",
        type: "linear",
        range: "height",
        nice: true,
        zero: true,
        domain: {
          data: "table",
          field: constants_1.sqlFields.category
        }
      }];
    }
  }, {
    key: "setMarks",
    value: function setMarks() {
      return [{
        name: "lines",
        interactive: false,
        type: "line",
        from: {
          data: "table"
        },
        encode: {
          enter: {
            x: {
              scale: "x",
              field: "x"
            },
            y: {
              scale: "y",
              field: "y"
            },
            strokeCap: {
              value: "round"
            },
            strokeWidth: {
              value: 2
            },
            strokeJoin: {
              value: "round"
            }
          }
        }
      }, {
        name: "points",
        interactive: false,
        type: "symbol",
        from: {
          data: "dots"
        },
        encode: {
          enter: {
            x: {
              scale: "x",
              field: "x"
            },
            y: {
              scale: "y",
              field: "y"
            }
          },
          update: {
            opacity: {
              value: 1
            }
          }
        }
      }, {
        name: "cell",
        type: "path",
        from: {
          data: "lines"
        },
        transform: [{
          type: "voronoi",
          x: "datum.x",
          y: "datum.y",
          size: [{
            signal: "width"
          }, {
            signal: "height"
          }]
        }],
        encode: {
          update: {
            path: {
              field: "path"
            },
            fill: {
              value: "red"
            },
            opacity: {
              value: 0
            }
          }
        }
      }];
    }
  }, {
    key: "setAxes",
    value: function setAxes() {
      return [Object.assign(Object.assign({
        orient: "bottom",
        scale: "x"
      }, this.isDate() ? {
        encode: {
          labels: {
            update: {
              text: {
                signal: "utcFormat(datum.value, '".concat(this.resolveFormat('x'), "')")
              }
            }
          }
        }
      } : {}), {
        labelOverlap: "parity",
        ticks: false
      }), {
        orient: "left",
        scale: "y",
        labelOverlap: "parity",
        format: this.resolveFormat('y'),
        titleLimit: {
          "signal": "height"
        },
        encode: {
          labels: {
            update: {
              align: {
                value: "right"
              },
              baseline: {
                value: "bottom"
              }
            }
          }
        }
      }];
    }
  }, {
    key: "bindData",
    value: function bindData() {
      var widgetData = this.store.editor.widgetData;
      return [Object.assign(Object.assign({
        values: widgetData,
        name: "table"
      }, this.isDate() ? {
        format: {
          parse: {
            x: 'date'
          }
        }
      } : {}), {
        transform: this.resolveEndUserFiltersTransforms()
      }), {
        name: "dots",
        source: "table",
        transform: [{
          type: "filter",
          expr: "hover && hover.datum.x === datum.x"
        }]
      }];
    }
  }, {
    key: "getChart",
    value: function getChart() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.generateSchema();

              case 2:
                this.setGenericSettings();
                return _context2.abrupt("return", this.schema);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return Line;
}(chart_common_1["default"]);

exports["default"] = Line;